const article = {
    id: 'work-tracker',
    title: 'Work tracker',
    summary: 'For one client and a date range, see how waiting work, new work, and finished work moved, including packing and outbound.',
    publishedAt: '2026-08-18',
    tags: ['tracker', 'packing'],
    sections: [
        {
            type: 'paragraph',
            text: 'Work tracker summarizes how a client’s queue changed between two dates. Packing and outbound are included with the other processes, and each metric has a short explanation.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when you want a period view of inflow and completion, not the live floor screen.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Tracker.',
                'Select a client and the from and to dates.',
                'Submit the form.',
                'Read waiting, new, and finished work. Hover a metric if the label needs a definition.',
            ],
        },
    ],
};

export default article;
